import styled from "styled-components";

interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}
export const Styles = styled.div<IProps>`
  border: 1px solid #d9d9d9;
  height: 40px;
  padding: 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
`;
